export default __webpack_public_path__ + "static/media/craon37.2d7859ef.jpg";